import type { useDeliverySectionModel } from '@/components/home/components/delivery-section/delivery-section.model'

type DeliverySectionViewProps = ReturnType<typeof useDeliverySectionModel>

export function DeliverySectionView({
  headlineText,
  bodyText,
  noteText,
  stageInert,
  blockStyle,
}: DeliverySectionViewProps) {
  return (
    <section className="fz-delivery">
      <div className="fz-delivery__stage" inert={stageInert || undefined}>
        <div className="fz-delivery__block" style={blockStyle}>
          <svg
            className="fz-delivery__route"
            viewBox="0 0 120 60"
            aria-hidden="true"
            focusable="false"
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeDasharray="3 5"
              strokeLinecap="round"
              d="M8 46 C 40 46, 44 14, 74 14 C 96 14, 100 30, 112 30"
            />
            <circle cx="8" cy="46" r="3.5" fill="currentColor" />
            <path
              fill="currentColor"
              d="M112 20 C 108 20, 105 23, 105 27 C 105 32, 112 40, 112 40 C 112 40, 119 32, 119 27 C 119 23, 116 20, 112 20 Z"
            />
          </svg>
          <p className="fz-delivery__headline">{headlineText}</p>
          <p className="fz-delivery__body">{bodyText}</p>
          <p className="fz-delivery__note">{noteText}</p>
        </div>
      </div>
    </section>
  )
}
